<template>
    <div>
        <div class="eHeader_bg" :class="isVip? 'vip_bg':'no_vip_bg'">
                <topNavVue :style="isVip? 'border-bottom: none':''" :color="isVip? '#ffffff':'#999999'"></topNavVue>
                <div class="container flex items-center justify-between" style="height: 94px;">
                    <div class="flex items-center">
                        <div style="width: 55px;height: 55px;;">
                            <el-image :src="require('@/assets/home/e_logo.png')" style="width: 55px; height: 55px;"></el-image>
                        </div>
                        <div class="marginL15" :class="isVip? 'colorFFF':''">
                            <div class="font16 font-bold">
                                <span class="marginR10">{{dataForm.enterpriseName}} </span>
                                <span v-if="isVip" >
                                    <span class="marginR10 font12 borderRadius5"  style="border: 1px solid #898686; padding:1px 5px;" v-for="(item, index) in dataForm.techniquesInfo" :key="item">
                                        <span class="paddingL10 paddingR10">{{ item}}</span>
                                    </span>
                                </span>
                                <span v-else>
                                    <el-tag class="marginR10" type="danger" size="small" v-for="(item, index) in dataForm.techniquesInfo" :key="item" effect="plain">
                                        <span class="paddingL10 paddingR10">{{ item }}</span>
                                    </el-tag>
                                </span>
                            </div>
                            <div class="marginT15 color86">
                                <i class="el-icon-location-outline"></i>
                                <span class="marginR20 font13">{{dataForm.regionInfo}}</span>
                                <span class="marginR20 borderRadius5" style="border: 1px solid #898686; padding:1px 5px;" v-for="(item, index) in dataForm.serviceIndustry" :key="index">{{ item | dict('service_industry') }}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-button plain  
                        :disabled="$gfn.disabledPerm([1,5]) !=false"
                        @click="go_favorites" v-if="$route.query.itemId !== userInfo.companyId">
                            <div class="flex justify-center items-center" v-if="isCollection == false">
                                <span class="font18 el-icon-star-on"></span>
                                <span class="font18">加入收藏</span>
                            </div>
                            <div class="flex justify-center items-center" v-if="isCollection == true">
                                <span class="font18 el-icon-star-off"></span>
                                <span class="font18">取消收藏</span>
                            </div>
                        </el-button>
                        
                        <el-tooltip class="item" effect="dark"  placement="bottom"
                        :content="authPermResult == 9? '您还未登陆，请登录后再操作':authPermResult == 2?'您还未认证,请认证后再去沟通':'当前用户无权操作'"
                        :disabled="authPermResult == false">
                             <el-button type="primary" :disabled="authPermResult != false" @click="go_chat">
                                <span class="font18 el-icon-chat-dot-round"></span>
                                <span class="font18">在线沟通</span>
                            </el-button>
                        </el-tooltip>

                        <!-- <el-tooltip class="item" effect="dark" placement="top"
                        :content="authPermResult == 9? '您还未登陆，请登录后再操作':authPermResult == 2?'您还未认证,请认证后再去沟通':'当前用户无权操作'"
                        :disabled="authPermResult == false">
                            <el-button
                            :disabled="authPermResult != false"
                            :type="authPermResult  != false? 'planRed':'planRed'"
                            icon="el-icon-s-comment font18"  style="width: 190px;height: 57px;" @click="go_chat">
                                <span class="font18">在线沟通</span>
                            </el-button>
                        </el-tooltip> -->

                        <!-- <el-button type="primary"
                        :disabled="$gfn.disabledPerm([1,5]) !=false"
                        @click="go_chat" v-if="$route.query.itemId !== userInfo.companyId">
                            <span class="font20 el-icon-chat-dot-round"></span>
                            <span class="font18">在线沟通</span>
                        </el-button> -->
                    </div>
                </div>
                <!-- 菜单项 -->
                <div class="container flex items-center marginT10" :class="isVip? 'colorFFF':'color666'">
                    <div class="e_menuItem" v-for="item in menuList" :key="item.id" :class="active_menuNav(item.path)"
                    @click="go_route(item.path)">{{ item.name }}</div>
                </div>
        </div>
        <router-view :key="$route.fullPath"></router-view>
        <shortFooter></shortFooter>
        <div v-show="isScrolledToTarget" class="goTop bgcRed" @click="go_top">
            <i class="el-icon-top" style="margin-right: 2px;"></i>
        </div>
        <chatUserVue v-if="chatUser"  :dialogVisible.sync="chatUser" :chatUserObj="chatUserObj"  @close="chatUser=false"></chatUserVue>
    </div>
</template>

<script>
import shortFooter from '@/components/footer/short_index.vue'
import topNavVue from './components/top_nav.vue'
import {enterpriseShow} from "@/api/home";
import chatUserVue from '@/components/chat_user/index.vue'
import {collectionEnterprise,cancelCollection,collectionRelation} from '@/api/common'

    export default {
        name:'',
        props:[''],
        data () {
            return {
                isVip:false,//是否VIP
                isCollection:false,//是否收藏
                chatUser:false,
                isScrolledToTarget: false,
                menuList:[],
                dataForm: {},

                chatUserObj:{
                    chatType:'',//沟通类型  厂家信息
                    itemId:'',//内容ID
                    perms:[1,5],//权限
                    enterpriseId:'',//企业ID
                }
            }
        },
        components: {
            topNavVue,
            shortFooter,
            chatUserVue
        },
        computed: {
             authPermResult() {
                return this.$gfn.authPerm([1,5])
            },
            disabledPermResult() {
                return this.$gfn.disabledPerm([1,5])
            },
            isLogin(){
                return this.$store.getters.isLogin
            },
            userInfo(){
                return this.$store.getters.userInfo
            },
            routePath(){
                return this.$route.path
            },
        },
        beforeMount() {},
        mounted() {
            if(this.$route.query.itemId){

            }else{
                this.$router.push({path:'/'})
            }
            this.get_enterprise()
            this.$nextTick(() => {// 为 el-scrollbar 的滚动容器添加滚动事件监听
                // if (this.$refs.eScroll) {
                //     const scrollWrap = this.$refs.eScroll.$refs.wrap;// 获取滚动容器元素
                //     scrollWrap.addEventListener('scroll', this.eHandleScroll);// 添加滚动事件监听器
                // }
                window.addEventListener('scroll', this.handleScroll)
            });
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll)
            // if (this.$refs.eScroll) {
            //     const scrollWrap = this.$refs.eScroll.$refs.wrap;
            //     if (scrollWrap) {
            //         scrollWrap.removeEventListener('scroll', this.eHandleScroll);
            //     }
            // }
        },
        methods: {
            active_menuNav(path){//激活菜单
                if(path == this.routePath && this.isVip){
                    return 'active_menuItem'
                }else if(path == this.routePath && !this.isVip){
                    return 'active_menuItem2'
                }else{
                    return ''
                }
            },
            go_chat(){
                if(this.routePath == '/supplier_info'){
                    this.chatUserObj.chatType ='sales'
                }else{
                    this.chatUserObj.chatType ='production'
                }
                this.chatUserObj.itemId=this.dataForm.id
                this.chatUserObj.enterpriseId=this.dataForm.id
                this.chatUser=true
            },
            get_menuList(){
                if(this.dataForm.companyRole == '1' || this.dataForm.companyRole == '5'){//采购商
                    this.menuList=[
                        {id:1,name:'企业主页',path:'/factory_info'},
                        {id:2,name:'多媒体中心',path:'/multimedia'},
                    ]
                }else if(this.dataForm.companyRole == '2'){//供应商
                    this.menuList=[
                        {id:1,name:'企业主页',path:'/factory_info'},
                        {id:2,name:'多媒体中心',path:'/multimedia'},
                        {id:6,name:'产品中心',path:'/typical_products'},
                        // {id:7,name:'典型客户',path:'/typical_customers'},
                        // {id:8,name:'资质信息',path:'/qualification'},
                        // {id:9,name:'工商信息',path:'/company_profile'},
                        // {id:10,name:'联系我们',path:'/contact_us'},
                    ]
                }else if(this.dataForm.companyRole == '3'){
                    this.menuList=[
                        {id:1,name:'企业主页',path:'/factory_info'},
                        {id:2,name:'多媒体中心',path:'/multimedia'},
                        {id:3,name:'生产与工艺',path:'/production'},
                        {id:4,name:'产品中心',path:'/typical_products'},

                    ]
                }
            },
            go_favorites(){//加入收藏
                if(this.isCollection){
                    this.$confirm('确定要取消收藏吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        cancelCollection(this.dataForm.id).then(res=>{
                            this.get_enterprise()
                            this.$message.success(res.message)
                        })
                    })
                }else{
                    this.$confirm('确要收藏该企业吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        collectionEnterprise(this.dataForm.id).then(res=>{
                            this.get_enterprise()
                            this.$message.success(res.message)
                        })
                    })
                }
                
            },
            go_route(path){
                this.$router.push({path:path,query:{itemId:this.$route.query.itemId}})
            },
            // eHandleScroll(e){//监听滚动
            //     const eInfoDom = this.$refs.e_info_dom
            //     const scrollTop = e.target.scrollTop;
            //     if (scrollTop > 200) {// 判断是否超过 200px
            //         this.isScrolledToTarget = true;
            //     } else {
            //         this.isScrolledToTarget = false;
            //     }
            // },
            handleScroll() {
                // 获取当前滚动条距离顶部的距离
                // pageYOffset 兼容性好，也可以用 document.documentElement.scrollTop
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // 判断是否超过 200px
                if (scrollTop > 200) {
                    this.isScrolledToTarget = true
                } else {
                    this.isScrolledToTarget = false
                }
            },
            go_top(){//滚动到 顶部
                // this.$refs.eScroll.$refs.wrap.scrollTo({
                //     top: 0,
                //     behavior: 'smooth' // 平滑滚动
                // })
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动
                })
            },
            get_enterprise() {//企业详情
                enterpriseShow(this.$route.query.itemId).then(res => {
                    this.dataForm = res.data
                    console.log(JSON.parse(JSON.stringify(res.data)),'i企业详情')
                    this.get_menuList()
                    if(this.isLogin){
                        this.get_collectionRelation()
                    }
                })
            },
            get_collectionRelation(){//收藏关系
                collectionRelation(this.dataForm.id).then(res=>{
                    this.isCollection = res.data
                })
            },
        },
    }

</script>

<style lang='scss' scoped>
.eHeader_bg{
    height: 172px;
    min-width: 1200px;
}
.vip_bg{
    background-repeat: no-repeat;       // 1. 不平铺
    background-size: cover;             // 2. 自适应覆盖（保持比例，填满容器，多余部分裁剪）
    background-position: center center; // 3. 居中显示
    background-image: url('@/assets/home/e_bg@2x.png');
}
.no_vip_bg{
    background-repeat: no-repeat;       // 1. 不平铺
    background-size: cover;             // 2. 自适应覆盖（保持比例，填满容器，多余部分裁剪）
    background-position: center center; // 3. 居中显示
    background-image: url('@/assets/home/bg_no_vip@2x.png');
}
.e_menuItem{
    cursor: pointer;
    margin-right: 40px;
    font-size: 14px;
    font-weight: normal;

}
.active_menuItem{
    position: relative;
    &::after{
        content: '';
        position: absolute;
        width: 100%;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
        border-bottom: 2px solid #fff;
    }
}
.active_menuItem2{
    position: relative;
    color: #ED1D24;
    &::after{
        content: '';
        position: absolute;
        width: 100%;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
        border-bottom: 2px solid #ED1D24;
    }
}
.goTop{
    position: fixed;
    right: 20px;
    bottom: 100px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    color: #ffffff;
    font-size: 26px;
    text-align: center;
    line-height: 40px;
    transition: background-color 0.3s ease; /* 高度变化带动画 */
    cursor: pointer;
    z-index: 99999;
    &:hover{
        background-color: #000000;
    }
}
::v-deep .el-scrollbar__wrap{ overflow-x: hidden; }
</style>
